const select =
  'id,reportTokenId,headers,dataType,logs,ip,method,created,updated,isSuccessfullyRequest';

export default {
  paged: {
    select: `${select}`,
    searchSelect: [],
    notSelectSearch: 'id,reportTokenId,headers,created,updated,isSuccessfullyRequest',
  },
  detail: {
    select: `${select}`,
  },
};
